import { useSelector } from 'react-redux';
import { selectGlobalUser } from '../globalSlice';

export const useAuth = () => {
  const { user, loading, error } = useSelector(selectGlobalUser);
  return { user, loading, error };
};
